module.exports = __webpack_public_path__ + "img/xishanju-logo.a9cf6336.png";